module.exports = __webpack_public_path__ + "img/wechat.c72f373d.svg";